module.exports = __webpack_public_path__ + "img/leiterinnen_sabrina-buesser.1edd01f3.png";